import { WithTheme } from "./withTheme";
import { WithLocalization } from "./withLozalization";
import { WithSnackbar } from "./withSnackbar";
import { WithRouter } from "./withRouter";
import compose from "compose-function";
import { WithSuspense } from "./withSuspense";
import { WithRedux } from "./withRedux";

const WithProviders = compose(
  WithSuspense,
  WithSnackbar,
  WithLocalization,
  WithTheme,
  WithRouter,
  WithRedux
);

export default WithProviders;
